import { JsonLd } from "../JsonLd";

const SITE_LD = "https://fedevo20.fr";
const LOGO = "https://customer-assets.emergentagent.com/job_tv-broadcast-4/artifacts/p88vdzfy_fedevo%20logo%20tv%20jaune.png";

const SITE_GRAPH = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${SITE_LD}#org`,
      "name": "Fedevo 2.0 · Urban Media",
      "alternateName": ["Fedevo 2.0", "Fédération Vaudaise du Hip-Hop et des Cultures Urbaines", "FVHHCU"],
      "url": SITE_LD,
      "logo": LOGO,
      "foundingDate": "2010-09",
      "description": "Média urbain spécialisé streaming — hip-hop, graff, break, DJ, beatbox et culture urbaine.",
      "sameAs": ["https://alliancemusik.com/", "https://www.kreyol-kitchen.fr/", "https://www.graff-ik-art.fr/"],
    },
    {
      "@type": "WebSite",
      "@id": `${SITE_LD}#site`,
      "url": SITE_LD,
      "name": "Fedevo 2.0",
      "publisher": { "@id": `${SITE_LD}#org` },
      "inLanguage": "fr",
      "potentialAction": {
        "@type": "SearchAction",
        "target": `${SITE_LD}/search?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "BroadcastService",
      "@id": `${SITE_LD}#broadcast`,
      "name": "Fedevo 2.0 TV",
      "broadcastDisplayName": "Fedevo 2.0 · média urbain spécialisé streaming",
      "area": "FR",
      "inLanguage": "fr",
      "publisher": { "@id": `${SITE_LD}#org` },
    },
  ],
};

export const SiteJsonLd = () => <JsonLd data={SITE_GRAPH} />;
export { LOGO };
